import React from 'react';
import { Capacitor } from '@capacitor/core';

const isNative = Capacitor.isNativePlatform();

function AboutUs() {
  return (
    <div style={{ backgroundColor: 'rgba(0,0,0,0.7)', padding: '30px', borderRadius: '8px', maxWidth: '900px', margin: 'auto', textAlign: 'left', lineHeight: '1.6', border: '1px solid #444', color: '#e0e0e0' }}>
      <h2 style={{ textAlign: 'center', color: '#ff9800', fontSize: '2em', marginBottom: '5px' }}>The Ultimate Guide to WHATIF Dungeon For Riches</h2>
      <p style={{ textAlign: 'center', fontStyle: 'italic', color: '#aaa', marginTop: '0' }}>Version 3.1 (Exponential Scaling & Ecosystem Protocol)</p>
      <hr style={{ borderColor: '#444', margin: '20px 0' }} />

      <p>Welcome to <strong>WHATIF Dungeon For Riches</strong>, a persistent, web-based ecosystem built on the WAX Blockchain. Stake NFTs for Mining Power (MP), embark on dungeon mining expeditions, form gangs, and stake tokens in the Vault to earn rewards.</p>

      <ul style={{ color: '#ccc', backgroundColor: 'rgba(255,255,255,0.05)', padding: '15px 15px 15px 35px', borderRadius: '5px' }}>
        <li><strong>Game URL:</strong> rewardsinwhatif.app</li>
        <li><strong>Collection Name:</strong> whatifreward</li>
        <li><strong>Schemas Supported:</strong> deeds, fireman, gear, emblems, gangpass, packs</li>
      </ul>

      <h3 style={{ color: '#00e5ff', marginTop: '30px', borderBottom: '1px solid #333', paddingBottom: '5px' }}>1. The Core Loop & Dungeon Mechanics</h3>
      <p>The primary way to earn Daily Points is by sending your Mining Power (MP) on Dungeon Runs.</p>
      <ul>
        <li><strong>Mining Power (MP) & Equipment:</strong> Base MP is generated by staking supported partner NFTs in the Armoury. Amplification is achieved by equipping Gear to the 6 dedicated slots (Sword, Shield, Boots, Book, Charm, Crest).</li>
        <li><strong>Diminishing Returns:</strong> Percentage-based Gear Boosts scale dynamically: 0–200% is 100% effective, 201–500% is 50% effective, 501–1000% is 25% effective, and 1001%+ is 10% effective. Flat boosts (like Max Stamina) bypass diminishing returns entirely.</li>
        <li><strong>Dungeon Durations:</strong> Runs cost between 5 and 100 Stamina across base durations of 5 Minutes, 15 Minutes, 1 Hour, 8 Hours, and 24 Hours.</li>
        <li><strong>Exponential Speed Scaling:</strong> Speed Boosts reduce run duration using the asymptotic formula <code>Active Time = Base Time / (2 ^ (Speed Boost / 100))</code>. Every +100% Speed Boost cuts the timer in half (100% = 50% time, 200% = 25% time), ensuring runs never drop to zero.</li>
        <li><strong>Zero Stamina Penalty:</strong> Running dungeons with 0 Stamina doubles the timer, doubles the negative stamina cost, and cuts point earnings in half.</li>
      </ul>

      {!isNative && (
        <>
        <h3 style={{ color: '#00e5ff', marginTop: '30px', borderBottom: '1px solid #333', paddingBottom: '5px' }}>2. The Investor Protocol & Ecosystem Resets</h3>
              <p>The top 50% of eligible daily players win a reward pack (scaled by your NFT Gain Chance). To qualify for Daily Rewards and partner token airdrops, you MUST meet the <strong>Investor Protocol</strong>:</p>
              <ol style={{ color: '#ccc' }}>
                <li><strong>Player Level:</strong> Level 2 or higher.</li>
                <li><strong>Daily Points:</strong> Accumulate 2,500+ Daily Points.</li>
                <li><strong>Vault Score:</strong> Maintain a Vault Score of 250,000+.</li>
              </ol>
              <ul>
                <li><strong>Daily Sprint Reset (08:00 AM ET):</strong> Daily Points wipe and roll over proportionally into your Monthly Season Score.</li>
                <li><strong>Monthly Season Finalization (1st of Month 09:00 ET):</strong> A pool of 20,000,000 FIREMAN is distributed: 90% must be claimed by players proportionally based on Monthly Points, and 10% to 10 random lottery winners.</li>
              </ul>

              <h3 style={{ color: '#00e5ff', marginTop: '30px', borderBottom: '1px solid #333', paddingBottom: '5px' }}>3. The Smart Contract Vault (Staking)</h3>
              <p>The Vault allows you to stake tokens on-chain to earn APR and universal account multipliers.</p>
              <ul>
                <li><strong>Halving Schedule:</strong> Token reward rates are subject to halving multipliers: 0.5x in 2026, 0.25x in 2027, and 0.125x in 2028.</li>
                <li><strong>The Watchtower Furnace:</strong> Permanently burn a <em>Watchtower Yield Emblem</em> NFT to add a temporary +0.25% APR boost to your Vault for 24 hours.</li>
                <li><strong>Claim Cooldown:</strong> Reward claims are subject to a 6-hour cooldown.</li>
              </ul>

              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', marginTop: '10px', fontSize: '14px' }}>
                  <thead>
                    <tr style={{ borderBottom: '2px solid #555', color: '#ff9800', backgroundColor: 'rgba(255,255,255,0.05)' }}>
                      <th style={{ padding: '10px' }}>Token</th>
                      <th style={{ padding: '10px' }}>Tier 1 (+10%)</th>
                      <th style={{ padding: '10px' }}>Tier 2 (+25%)</th>
                      <th style={{ padding: '10px' }}>Tier 3 (+50%)</th>
                      <th style={{ padding: '10px' }}>Max Stake Cap</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style={{ borderBottom: '1px solid #333' }}>
                      <td style={{ padding: '10px', fontWeight: 'bold' }}>FIREMAN</td>
                      <td style={{ padding: '10px' }}>50,000</td>
                      <td style={{ padding: '10px' }}>125,000</td>
                      <td style={{ padding: '10px' }}>250,000</td>
                      <td style={{ padding: '10px' }}>250,000</td>
                    </tr>
                    <tr style={{ borderBottom: '1px solid #333' }}>
                      <td style={{ padding: '10px', fontWeight: 'bold' }}>WHATIF</td>
                      <td style={{ padding: '10px' }}>3,000,000</td>
                      <td style={{ padding: '10px' }}>7,500,000</td>
                      <td style={{ padding: '10px' }}>15,000,000</td>
                      <td style={{ padding: '10px' }}>15,000,000</td>
                    </tr>
                    <tr style={{ borderBottom: '1px solid #333' }}>
                      <td style={{ padding: '10px', fontWeight: 'bold' }}>WTFWUF</td>
                      <td style={{ padding: '10px' }}>21,800</td>
                      <td style={{ padding: '10px' }}>54,500</td>
                      <td style={{ padding: '10px' }}>109,000</td>
                      <td style={{ padding: '10px' }}>109,000</td>
                    </tr>
                    <tr style={{ borderBottom: '1px solid #333' }}>
                      <td style={{ padding: '10px', fontWeight: 'bold' }}>PUZZL</td>
                      <td style={{ padding: '10px' }}>1,800</td>
                      <td style={{ padding: '10px' }}>4,500</td>
                      <td style={{ padding: '10px' }}>9,000</td>
                      <td style={{ padding: '10px' }}>9,000</td>
                    </tr>
                    <tr style={{ borderBottom: '1px solid #333' }}>
                      <td style={{ padding: '10px', fontWeight: 'bold' }}>WHATIFX</td>
                      <td style={{ padding: '10px' }}>800</td>
                      <td style={{ padding: '10px' }}>2,000</td>
                      <td style={{ padding: '10px' }}>4,000</td>
                      <td style={{ padding: '10px' }}>4,000</td>
                    </tr>
                    <tr style={{ borderBottom: '1px solid #333' }}>
                      <td style={{ padding: '10px', fontWeight: 'bold' }}>TESTERU</td>
                      <td style={{ padding: '10px' }}>5,000</td>
                      <td style={{ padding: '10px' }}>12,500</td>
                      <td style={{ padding: '10px' }}>25,000</td>
                      <td style={{ padding: '10px' }}>25,000</td>
                    </tr>
                    <tr style={{ borderBottom: '1px solid #333' }}>
                      <td style={{ padding: '10px', fontWeight: 'bold' }}>WTFBILL</td>
                      <td style={{ padding: '10px' }}>3</td>
                      <td style={{ padding: '10px' }}>8</td>
                      <td style={{ padding: '10px' }}>15</td>
                      <td style={{ padding: '10px' }}>15</td>
                    </tr>
                    <tr style={{ borderBottom: '1px solid #333' }}>
                      <td style={{ padding: '10px', fontWeight: 'bold' }}>XMASZS</td>
                      <td style={{ padding: '10px' }}>15</td>
                      <td style={{ padding: '10px' }}>37.5</td>
                      <td style={{ padding: '10px' }}>75</td>
                      <td style={{ padding: '10px' }}>75</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              </>
      )}

      <h3 style={{ color: '#00e5ff', marginTop: '30px', borderBottom: '1px solid #333', paddingBottom: '5px' }}>4. Gangs & Upgrades</h3>
      <p>Form Gangs to pool resources and upgrade shared buildings.</p>
      <ul>
        <li><strong>Creation Cost:</strong> 1,000,000 WHATIF + 1 Active "Gang Pass" NFT (Template #899554).</li>
        <li><strong>Gang Treasury:</strong> Members deposit tokens to fund building upgrades.</li>
        <li><strong>Upgrade Mechanics:</strong>
          <ul>
            <li><strong>Cost Formula:</strong> <code>BaseCost * (2 ^ Level)</code></li>
            <li><strong>Cooldown Formula:</strong> Starts at 24 hours, doubling every level up to 16 days maximum.</li>
          </ul>
        </li>
      </ul>

      <h3 style={{ color: '#00e5ff', marginTop: '30px', borderBottom: '1px solid #333', paddingBottom: '5px' }}>5. Minigames & Utility</h3>
      <ul style={{ listStyleType: 'circle' }}>
        <li><strong>The Alchemist's Forge:</strong> Burn NFTs and tokens to craft rarer assets on-chain.</li>
        <li><strong>Unboxing Station:</strong> Open earned packs using server-side verified RNG.</li>
        {!isNative && <li><strong>Rocket Crash:</strong> Bet FIREMAN tokens on a rising multiplier. Cash out before the crash and qualify for progressive Grand Jackpots.</li>}
        {!isNative && <li><strong>Faucet:</strong> Claim 5 free FIREMAN every 60 minutes.</li>}
      </ul>

      <h3 style={{ color: '#00e5ff', marginTop: '30px', borderBottom: '1px solid #333', paddingBottom: '5px' }}>6. Troubleshooting & Common Issues</h3>

      <div style={{ backgroundColor: 'rgba(255, 75, 43, 0.1)', borderLeft: '4px solid #ff4b2b', padding: '15px', marginBottom: '20px' }}>
        <h4 style={{ color: '#ff4b2b', marginTop: '0' }}>1. Wallet Won't Connect / Login Failing</h4>
        <p style={{ margin: '5px 0' }}><strong>Fix:</strong> Ensure pop-ups are allowed. Log in to your wallet app (Anchor, Cloud Wallet) before connecting. Clear browser cache if issues persist.</p>
      </div>

      <div style={{ backgroundColor: 'rgba(255, 152, 0, 0.1)', borderLeft: '4px solid #ff9800', padding: '15px', marginBottom: '20px' }}>
        <h4 style={{ color: '#ff9800', marginTop: '0' }}>2. "Transaction Failed" or CPU/NET Errors</h4>
        <p style={{ margin: '5px 0' }}><strong>Fix:</strong> Antelope actions require CPU resources. Stake additional WAX to CPU via a block explorer if transactions fail.</p>
      </div>

      <div style={{ backgroundColor: 'rgba(76, 175, 80, 0.1)', borderLeft: '4px solid #4caf50', padding: '15px', marginBottom: '20px' }}>
        <h4 style={{ color: '#4caf50', marginTop: '0' }}>3. NFTs Not Showing Up</h4>
        <p style={{ margin: '5px 0' }}><strong>Fix:</strong> Verify NFTs belong to supported schemas. Staked Armoury NFTs cannot be equipped for dungeons simultaneously.</p>
      </div>


      
      
      
      <h3 style={{ color: '#00e5ff', marginTop: '30px', borderBottom: '1px solid #333', paddingBottom: '5px' }}>7. Mining Power (MP) NFTs Reference</h3>
      <p>Below is the comprehensive list of all NFTs that provide Base Mining Power (Armoury) or MP Boost (Gear/Emblems), sourced directly from the on-chain contract logic. Click any name to view it on AtomicHub.</p>

      <h4 style={{ color: '#ff9800' }}>Round 3 Beasts & Phoenix Line (8x MP)</h4>
      <p>Round 3 replaces the Round 2 Beasts, Phoenix line and Gateway/Ascension/Omniverse Coins with 8x the MP (the coins keep the same effect). An NFT staked in a WaxDAO farm can't be staked, equipped or blended here &mdash; unstake it on WaxDAO first.</p>
      <div style={{ overflowX: 'auto', marginBottom: '20px', border: '1px solid #444' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '14px' }}>
          <thead>
            <tr style={{ borderBottom: '2px solid #555', color: '#ff9800' }}>
              <th style={{ padding: '10px' }}>Name / Template ID</th>
              <th style={{ padding: '10px' }}>Rarity</th>
              <th style={{ padding: '10px' }}>Base MP</th>
              <th style={{ padding: '10px' }}>Replaces</th>
            </tr>
          </thead>
          <tbody>
            {[
              [910131, 'Ascended FIREMAN PHOENIX + WTFWUF', 'Ascended Mystic', 104320, 884627],
              [910145, 'FIREMAN PHOENIX + WTFWUF', 'Mystic', 52160, 884624],
              [910133, 'Phoenix + WTFWUF', 'Mystic', 8960, 881084],
              [910139, 'Phoenix', 'Mystic', 6400, 880461],
              [910134, 'Serpent + WTFWUF', 'Legendary', 4480, 881083],
              [910140, 'Serpent', 'Legendary', 3200, 880460],
              [910135, 'Dragon + WTFWUF', 'Epic', 2240, 881082],
              [910141, 'Dragon', 'Epic', 1600, 880456],
              [910136, 'Chimera + WTFWUF', 'Rare', 1120, 881081],
              [910142, 'Chimera', 'Rare', 800, 880455],
              [910137, 'Kraken + WTFWUF', 'Uncommon', 560, 881080],
              [910143, 'Kraken', 'Uncommon', 400, 880454],
              [910138, 'Cyclops + WTFWUF', 'Common', 280, 881079],
              [910144, 'Cyclops', 'Common', 200, 880453],
            ].map(([id, nftName, rarity, mp, replaces]) => (
              <tr key={id} style={{ borderBottom: '1px solid #333' }}>
                <td style={{ padding: '10px', fontWeight: 'bold' }}>
                  <a href={`https://wax.atomichub.io/explorer/template/whatifreward/${id}`} target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                    {nftName}
                  </a>
                </td>
                <td style={{ padding: '10px' }}>{rarity}</td>
                <td style={{ padding: '10px' }}>{mp.toLocaleString()}</td>
                <td style={{ padding: '10px' }}>{replaces}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h4 style={{ color: '#ff9800' }}>Base MP (Specific Templates)</h4>
      <div style={{ overflowX: 'auto', maxHeight: '400px', marginBottom: '20px', border: '1px solid #444' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '14px' }}>
          <thead style={{ position: 'sticky', top: 0, backgroundColor: 'rgba(0,0,0,0.9)', zIndex: 1 }}>
            <tr style={{ borderBottom: '2px solid #555', color: '#ff9800' }}>
              <th style={{ padding: '10px' }}>Name / Template ID</th>
              <th style={{ padding: '10px' }}>Rarity</th>
              <th style={{ padding: '10px' }}>Base MP</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883995" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  PUZZLUM
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>2,109,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883994" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Tactilis
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>2,094,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883993" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Echochime
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>2,079,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883992" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Prismyn
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>2,064,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883991" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Structurion
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>2,049,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883965" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Codexa
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>2,034,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883964" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Synaptrix
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>2,019,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883963" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Mythospark
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>2,004,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883962" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Sketcha
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>1,989,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883961" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Halosent
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>1,974,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883960" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Compathor
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>1,959,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883959" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Kindrith
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>1,944,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883958" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Symbolyne
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>1,929,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883957" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Lexilume
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>1,914,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883956" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Aurora Voice
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>1,899,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883955" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Sequensa
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>1,884,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883954" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Gridlocke
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>1,869,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883953" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Modulynx
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>1,854,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883952" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Infinitune
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>1,839,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883951" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Dreambyte
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>1,824,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883950" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Novaheart
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>1,809,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883949" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Soundspire
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>1,794,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883948" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Puzzleforge
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>1,779,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883947" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Luminara
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>1,764,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883946" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Cognix
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>1,749,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883945" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Chronospark
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>1,734,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883944" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Soulwave
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>1,719,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883943" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Rhythmos
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>1,704,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/884252" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Focus Flare 
                </a>
              </td>
              <td style={{ padding: '10px' }}>Hero</td>
              <td style={{ padding: '10px' }}>1,689,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883756" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Heartbound Allies
                </a>
              </td>
              <td style={{ padding: '10px' }}>Mystic</td>
              <td style={{ padding: '10px' }}>844,800</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883754" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Champions of Concentration
                </a>
              </td>
              <td style={{ padding: '10px' }}>Legendary</td>
              <td style={{ padding: '10px' }}>422,400</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883751" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Masters of Patterns
                </a>
              </td>
              <td style={{ padding: '10px' }}>Epic</td>
              <td style={{ padding: '10px' }}>211,200</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883748" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Memory’s Luminaries
                </a>
              </td>
              <td style={{ padding: '10px' }}>Rare</td>
              <td style={{ padding: '10px' }}>105,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/syndicates21/905485" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  The Don
                </a>
              </td>
              <td style={{ padding: '10px' }}>Mystic</td>
              <td style={{ padding: '10px' }}>100,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/syndicates21/905356" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  The District
                </a>
              </td>
              <td style={{ padding: '10px' }}>Mystic</td>
              <td style={{ padding: '10px' }}>100,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883744" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Sonic Champions
                </a>
              </td>
              <td style={{ padding: '10px' }}>Uncommon</td>
              <td style={{ padding: '10px' }}>52,800</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/syndicates21/905484" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  The Underboss
                </a>
              </td>
              <td style={{ padding: '10px' }}>Legendary</td>
              <td style={{ padding: '10px' }}>50,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/syndicates21/905354" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  The Casino
                </a>
              </td>
              <td style={{ padding: '10px' }}>Legendary</td>
              <td style={{ padding: '10px' }}>50,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883741" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Champions of Precision
                </a>
              </td>
              <td style={{ padding: '10px' }}>Common</td>
              <td style={{ padding: '10px' }}>26,400</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/syndicates21/905483" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  The Capo
                </a>
              </td>
              <td style={{ padding: '10px' }}>Epic</td>
              <td style={{ padding: '10px' }}>25,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/syndicates21/905350" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Grand Hotel
                </a>
              </td>
              <td style={{ padding: '10px' }}>Epic</td>
              <td style={{ padding: '10px' }}>25,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/waxstation21/902993" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Mk-VI "The Singularity"
                </a>
              </td>
              <td style={{ padding: '10px' }}>Mystic</td>
              <td style={{ padding: '10px' }}>20,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889047" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Heartblade Of The Fire King
                </a>
              </td>
              <td style={{ padding: '10px' }}>Mystic</td>
              <td style={{ padding: '10px' }}>16,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889053" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Aegis Of The Flame Sentinel
                </a>
              </td>
              <td style={{ padding: '10px' }}>Mystic</td>
              <td style={{ padding: '10px' }}>16,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889083" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Solarstride Boots
                </a>
              </td>
              <td style={{ padding: '10px' }}>Mystic</td>
              <td style={{ padding: '10px' }}>16,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889142" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Halo Of The Eternal Flame
                </a>
              </td>
              <td style={{ padding: '10px' }}>Mystic</td>
              <td style={{ padding: '10px' }}>16,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889150" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Grimoire Of The Flame Seer
                </a>
              </td>
              <td style={{ padding: '10px' }}>Mystic</td>
              <td style={{ padding: '10px' }}>16,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889158" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Phoenix Eye Talisman
                </a>
              </td>
              <td style={{ padding: '10px' }}>Mystic</td>
              <td style={{ padding: '10px' }}>16,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883755" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Heart of Light
                </a>
              </td>
              <td style={{ padding: '10px' }}>Mystic</td>
              <td style={{ padding: '10px' }}>14,400</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/884627" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Ascended FIREMAN PHOENIX + WTFWUF
                </a>
              </td>
              <td style={{ padding: '10px' }}>Ascended Mystic</td>
              <td style={{ padding: '10px' }}>13,040</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/syndicates21/905482" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  The Soldato
                </a>
              </td>
              <td style={{ padding: '10px' }}>Rare</td>
              <td style={{ padding: '10px' }}>12,500</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/syndicates21/905347" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Speakeasy
                </a>
              </td>
              <td style={{ padding: '10px' }}>Rare</td>
              <td style={{ padding: '10px' }}>12,500</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883758" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Guardian of the Heart
                </a>
              </td>
              <td style={{ padding: '10px' }}>Mystic</td>
              <td style={{ padding: '10px' }}>12,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/899554" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Gang Pass
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>10,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/waxstation21/902992" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Mk-V "Void Walker"
                </a>
              </td>
              <td style={{ padding: '10px' }}>Legendary</td>
              <td style={{ padding: '10px' }}>10,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889046" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Sword Of Raging Fire
                </a>
              </td>
              <td style={{ padding: '10px' }}>Legendary</td>
              <td style={{ padding: '10px' }}>8,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889052" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Firewarden's Wall
                </a>
              </td>
              <td style={{ padding: '10px' }}>Legendary</td>
              <td style={{ padding: '10px' }}>8,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889082" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Embercore Warboots
                </a>
              </td>
              <td style={{ padding: '10px' }}>Legendary</td>
              <td style={{ padding: '10px' }}>8,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889141" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Ember Crest Of Glory
                </a>
              </td>
              <td style={{ padding: '10px' }}>Legendary</td>
              <td style={{ padding: '10px' }}>8,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889149" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Tome Of Blazing Knowledge
                </a>
              </td>
              <td style={{ padding: '10px' }}>Legendary</td>
              <td style={{ padding: '10px' }}>8,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889157" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Charm Of Fortune's Fire
                </a>
              </td>
              <td style={{ padding: '10px' }}>Legendary</td>
              <td style={{ padding: '10px' }}>8,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/syndicates21/905481" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  The Enforcer
                </a>
              </td>
              <td style={{ padding: '10px' }}>Uncommon</td>
              <td style={{ padding: '10px' }}>7,500</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/syndicates21/905346" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  The Docks
                </a>
              </td>
              <td style={{ padding: '10px' }}>Uncommon</td>
              <td style={{ padding: '10px' }}>7,500</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883752" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Beacon of Focus
                </a>
              </td>
              <td style={{ padding: '10px' }}>Legendary</td>
              <td style={{ padding: '10px' }}>7,200</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/884624" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  FIREMAN PHOENIX + WTFWUF
                </a>
              </td>
              <td style={{ padding: '10px' }}>Mystic</td>
              <td style={{ padding: '10px' }}>6,520</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883753" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Focus Catalyst
                </a>
              </td>
              <td style={{ padding: '10px' }}>Legendary</td>
              <td style={{ padding: '10px' }}>6,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/878281" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Fireheart Mystic
                </a>
              </td>
              <td style={{ padding: '10px' }}>Mystic</td>
              <td style={{ padding: '10px' }}>5,400</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333', background: 'rgba(0, 229, 255, 0.08)' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/909865" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  🔐 WHATIF Verified Master Keycard (#909865)
                </a>
              </td>
              <td style={{ padding: '10px', color: '#ffaa00' }}>Soulbound Key</td>
              <td style={{ padding: '10px', fontWeight: 'bold', color: '#00e5ff' }}>5,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/811278" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  The Timekeeper's Tower
                </a>
              </td>
              <td style={{ padding: '10px' }}>Mystic</td>
              <td style={{ padding: '10px' }}>5,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/818262" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  The Shrine of Infinite Pawsibilities
                </a>
              </td>
              <td style={{ padding: '10px' }}>Mystic</td>
              <td style={{ padding: '10px' }}>5,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/818462" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  The Feathered Fortune Teller
                </a>
              </td>
              <td style={{ padding: '10px' }}>Mystic</td>
              <td style={{ padding: '10px' }}>5,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/syndicates21/905480" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  The Goon
                </a>
              </td>
              <td style={{ padding: '10px' }}>Common</td>
              <td style={{ padding: '10px' }}>5,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/syndicates21/905345" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Back Alley
                </a>
              </td>
              <td style={{ padding: '10px' }}>Common</td>
              <td style={{ padding: '10px' }}>5,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/waxstation21/902991" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Mk-IV "Isotope"
                </a>
              </td>
              <td style={{ padding: '10px' }}>Epic</td>
              <td style={{ padding: '10px' }}>5,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/811276" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  WHATIF It Was Evermore Estates
                </a>
              </td>
              <td style={{ padding: '10px' }}>Legendary</td>
              <td style={{ padding: '10px' }}>4,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/818261" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Barkitecture of the Future
                </a>
              </td>
              <td style={{ padding: '10px' }}>Legendary</td>
              <td style={{ padding: '10px' }}>4,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/818460" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  King of What If
                </a>
              </td>
              <td style={{ padding: '10px' }}>Legendary</td>
              <td style={{ padding: '10px' }}>4,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889043" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Embersteel Flamefang
                </a>
              </td>
              <td style={{ padding: '10px' }}>Epic</td>
              <td style={{ padding: '10px' }}>4,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889051" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Lava Sentinel Plate
                </a>
              </td>
              <td style={{ padding: '10px' }}>Epic</td>
              <td style={{ padding: '10px' }}>4,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889081" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Magmastride Greaves
                </a>
              </td>
              <td style={{ padding: '10px' }}>Epic</td>
              <td style={{ padding: '10px' }}>4,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889140" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Insignia Of Blazing Might
                </a>
              </td>
              <td style={{ padding: '10px' }}>Epic</td>
              <td style={{ padding: '10px' }}>4,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889148" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Volcanic Lexicon Of Lore
                </a>
              </td>
              <td style={{ padding: '10px' }}>Epic</td>
              <td style={{ padding: '10px' }}>4,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889156" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Lucky Flame Relic
                </a>
              </td>
              <td style={{ padding: '10px' }}>Epic</td>
              <td style={{ padding: '10px' }}>4,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883750" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Architect of Insight
                </a>
              </td>
              <td style={{ padding: '10px' }}>Epic</td>
              <td style={{ padding: '10px' }}>3,600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/811275" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  The Guarded Castle Of Profits
                </a>
              </td>
              <td style={{ padding: '10px' }}>Epic</td>
              <td style={{ padding: '10px' }}>3,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/818259" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Doggy Dreamhouse
                </a>
              </td>
              <td style={{ padding: '10px' }}>Epic</td>
              <td style={{ padding: '10px' }}>3,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/818459" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Sunsetting Shoebill
                </a>
              </td>
              <td style={{ padding: '10px' }}>Epic</td>
              <td style={{ padding: '10px' }}>3,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883749" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Weaver of Connections
                </a>
              </td>
              <td style={{ padding: '10px' }}>Epic</td>
              <td style={{ padding: '10px' }}>3,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/waxstation21/902990" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Mk-III "Magma"
                </a>
              </td>
              <td style={{ padding: '10px' }}>Rare</td>
              <td style={{ padding: '10px' }}>2,500</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/811274" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Pinewood Estates
                </a>
              </td>
              <td style={{ padding: '10px' }}>Rare</td>
              <td style={{ padding: '10px' }}>2,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/818258" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Pawsibilities
                </a>
              </td>
              <td style={{ padding: '10px' }}>Rare</td>
              <td style={{ padding: '10px' }}>2,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/818457" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  A Curious Case of WHATIF
                </a>
              </td>
              <td style={{ padding: '10px' }}>Rare</td>
              <td style={{ padding: '10px' }}>2,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889017" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Inferno Edge
                </a>
              </td>
              <td style={{ padding: '10px' }}>Rare</td>
              <td style={{ padding: '10px' }}>2,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889050" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Flamewall Aegis
                </a>
              </td>
              <td style={{ padding: '10px' }}>Rare</td>
              <td style={{ padding: '10px' }}>2,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889080" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Flame-Hardened Boots
                </a>
              </td>
              <td style={{ padding: '10px' }}>Rare</td>
              <td style={{ padding: '10px' }}>2,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889139" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Crest Of Rising Flame
                </a>
              </td>
              <td style={{ padding: '10px' }}>Rare</td>
              <td style={{ padding: '10px' }}>2,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889147" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Seared Codex Of Insight
                </a>
              </td>
              <td style={{ padding: '10px' }}>Rare</td>
              <td style={{ padding: '10px' }}>2,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889155" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Charm Of The Ember Wind
                </a>
              </td>
              <td style={{ padding: '10px' }}>Rare</td>
              <td style={{ padding: '10px' }}>2,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/878279" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Ember Godking
                </a>
              </td>
              <td style={{ padding: '10px' }}>Legendary</td>
              <td style={{ padding: '10px' }}>1,800</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883747" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Chronicle of Brilliance
                </a>
              </td>
              <td style={{ padding: '10px' }}>Rare</td>
              <td style={{ padding: '10px' }}>1,800</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883745" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Guardian of Memories
                </a>
              </td>
              <td style={{ padding: '10px' }}>Rare</td>
              <td style={{ padding: '10px' }}>1,500</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/waxstation21/902989" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Mk-II "Badger"
                </a>
              </td>
              <td style={{ padding: '10px' }}>Uncommon</td>
              <td style={{ padding: '10px' }}>1,500</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/881084" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Phoenix + WTFWUF
                </a>
              </td>
              <td style={{ padding: '10px' }}>Mystic</td>
              <td style={{ padding: '10px' }}>1,120</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/811270" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Mossy Peaks Haven
                </a>
              </td>
              <td style={{ padding: '10px' }}>Common</td>
              <td style={{ padding: '10px' }}>1,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/818254" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  The House That WUF Built
                </a>
              </td>
              <td style={{ padding: '10px' }}>Common</td>
              <td style={{ padding: '10px' }}>1,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/818455" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  WTF It's A Blue Bill
                </a>
              </td>
              <td style={{ padding: '10px' }}>Common</td>
              <td style={{ padding: '10px' }}>1,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889016" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Blade Of The Molten Path
                </a>
              </td>
              <td style={{ padding: '10px' }}>Uncommon</td>
              <td style={{ padding: '10px' }}>1,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889049" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Ember-Runed Shield
                </a>
              </td>
              <td style={{ padding: '10px' }}>Uncommon</td>
              <td style={{ padding: '10px' }}>1,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889079" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Ember-Tread Boots
                </a>
              </td>
              <td style={{ padding: '10px' }}>Uncommon</td>
              <td style={{ padding: '10px' }}>1,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889138" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Flare Sigil Of Promise
                </a>
              </td>
              <td style={{ padding: '10px' }}>Uncommon</td>
              <td style={{ padding: '10px' }}>1,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889144" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Flickering Grimoire
                </a>
              </td>
              <td style={{ padding: '10px' }}>Uncommon</td>
              <td style={{ padding: '10px' }}>1,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889154" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Ignited Medallion
                </a>
              </td>
              <td style={{ padding: '10px' }}>Uncommon</td>
              <td style={{ padding: '10px' }}>1,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/waxstation21/902815" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Mk-I "Rustbucket"
                </a>
              </td>
              <td style={{ padding: '10px' }}>Common</td>
              <td style={{ padding: '10px' }}>1,000</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883743" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Echoes of Insight
                </a>
              </td>
              <td style={{ padding: '10px' }}>Uncommon</td>
              <td style={{ padding: '10px' }}>900</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/880461" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Phoenix 
                </a>
              </td>
              <td style={{ padding: '10px' }}>Mystic</td>
              <td style={{ padding: '10px' }}>800</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883742" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Harmony's Listener
                </a>
              </td>
              <td style={{ padding: '10px' }}>Uncommon</td>
              <td style={{ padding: '10px' }}>750</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/878274" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  WHATIF Flame Lord 
                </a>
              </td>
              <td style={{ padding: '10px' }}>Epic</td>
              <td style={{ padding: '10px' }}>600</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/881083" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Serpent + WTFWUF
                </a>
              </td>
              <td style={{ padding: '10px' }}>Legendary</td>
              <td style={{ padding: '10px' }}>560</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/834391" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Dan Deed
                </a>
              </td>
              <td style={{ padding: '10px' }}>Mystic</td>
              <td style={{ padding: '10px' }}>500</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889015" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Emberkind Training Sword
                </a>
              </td>
              <td style={{ padding: '10px' }}>Common</td>
              <td style={{ padding: '10px' }}>500</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889048" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Ember-Cracked Buckler
                </a>
              </td>
              <td style={{ padding: '10px' }}>Common</td>
              <td style={{ padding: '10px' }}>500</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889078" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Scorched Step Sandals
                </a>
              </td>
              <td style={{ padding: '10px' }}>Common</td>
              <td style={{ padding: '10px' }}>500</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889137" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Ashen Badge Of Effort
                </a>
              </td>
              <td style={{ padding: '10px' }}>Common</td>
              <td style={{ padding: '10px' }}>500</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889143" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Singed Pages Of Memory
                </a>
              </td>
              <td style={{ padding: '10px' }}>Common</td>
              <td style={{ padding: '10px' }}>500</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889153" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Coal Trinket Of Chance
                </a>
              </td>
              <td style={{ padding: '10px' }}>Common</td>
              <td style={{ padding: '10px' }}>500</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883740" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Visionary Precision
                </a>
              </td>
              <td style={{ padding: '10px' }}>Common</td>
              <td style={{ padding: '10px' }}>450</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/834345" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  WHATIF Deeds Foundation
                </a>
              </td>
              <td style={{ padding: '10px' }}>Legendary</td>
              <td style={{ padding: '10px' }}>400</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/880460" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Serpent
                </a>
              </td>
              <td style={{ padding: '10px' }}>Legendary</td>
              <td style={{ padding: '10px' }}>400</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/883737" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Precision Mind
                </a>
              </td>
              <td style={{ padding: '10px' }}>Common</td>
              <td style={{ padding: '10px' }}>375</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/pixeljourney/781515" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Pixel Journey
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>300</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/cleanupcentr/856817" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  EcoFlame Incinerator
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>300</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/cleanupcentr/882885" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Forestry Farm
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>300</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/cleanupcentr/894798" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Farm Cell
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>300</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/cleanupcentr/900810" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Common Seed Pack
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>300</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/cleanupcentr/900811" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Uncommon Seed Pack
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>300</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/cleanupcentr/900813" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Rare Seed Pack
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>300</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/cleanupcentr/900814" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Epic Seed Pack
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>300</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/cleanupcentr/900863" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  EcoFusion Compost
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>300</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/cleanupcentr/900884" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Common Plot
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>300</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/cleanupcentr/900920" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  EcoFusion Reactor
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>300</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/cleanupcentr/900921" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  EcoSpout
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>300</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/cleanupcentr/900922" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  EcoScythe
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>300</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/cleanupcentr/901532" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Simple Core
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>300</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/cleanupcentr/904726" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Compost Bag
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>300</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/cleanupcentr/904728" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Basic Tomato Seed
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>300</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/cleanupcentr/904729" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Enhanced Tomato Seed
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>300</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/cleanupcentr/904730" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Small Eco Crate
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>300</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/881082" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Dragon + WTFWUF
                </a>
              </td>
              <td style={{ padding: '10px' }}>Epic</td>
              <td style={{ padding: '10px' }}>280</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/834333" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  WHATIF Rewards Steel Beam
                </a>
              </td>
              <td style={{ padding: '10px' }}>Epic</td>
              <td style={{ padding: '10px' }}>200</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/878273" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Inferno Titan 
                </a>
              </td>
              <td style={{ padding: '10px' }}>Rare</td>
              <td style={{ padding: '10px' }}>200</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/880456" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Dragon
                </a>
              </td>
              <td style={{ padding: '10px' }}>Epic</td>
              <td style={{ padding: '10px' }}>200</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/881081" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Chimera + WTFWUF 
                </a>
              </td>
              <td style={{ padding: '10px' }}>Rare</td>
              <td style={{ padding: '10px' }}>140</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/834332" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Blueprint Layout
                </a>
              </td>
              <td style={{ padding: '10px' }}>Rare</td>
              <td style={{ padding: '10px' }}>100</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/880455" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Chimera
                </a>
              </td>
              <td style={{ padding: '10px' }}>Rare</td>
              <td style={{ padding: '10px' }}>100</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/878270" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Blaze Warden
                </a>
              </td>
              <td style={{ padding: '10px' }}>Uncommon</td>
              <td style={{ padding: '10px' }}>75</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/882959" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Super Power of Loyalty, Honesty, & Love
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>73</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/881080" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Kraken + WTFWUF
                </a>
              </td>
              <td style={{ padding: '10px' }}>Uncommon</td>
              <td style={{ padding: '10px' }}>70</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/834331" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Blueprint specs
                </a>
              </td>
              <td style={{ padding: '10px' }}>Common</td>
              <td style={{ padding: '10px' }}>50</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/837486" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Barracks Ration
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>50</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/841646" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Observatory Focus
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>50</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/870362" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Tester Up Token Emblem
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>50</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/871245" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Altar Fortune
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>50</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/872658" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Forge Fury
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>50</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/872679" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Scholar's Wisdom
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>50</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/880454" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Kraken
                </a>
              </td>
              <td style={{ padding: '10px' }}>Uncommon</td>
              <td style={{ padding: '10px' }}>50</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/886383" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Workshop Plating
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>50</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/881079" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Cyclops + WTFWUF
                </a>
              </td>
              <td style={{ padding: '10px' }}>Common</td>
              <td style={{ padding: '10px' }}>35</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/882958" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Super Power of Hyper Focused
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>29</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/878268" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  WHATIF Flameborn
                </a>
              </td>
              <td style={{ padding: '10px' }}>Common</td>
              <td style={{ padding: '10px' }}>25</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/880453" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Cyclops
                </a>
              </td>
              <td style={{ padding: '10px' }}>Common</td>
              <td style={{ padding: '10px' }}>25</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/882957" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Super Power of Pattern Recognition
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>12</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/882956" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Super Power of Memory
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>5</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/882955" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Super Power of Super Hearing
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>2</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/idaretodream/882954" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Super Power of Attention to Detail
                </a>
              </td>
              <td style={{ padding: '10px' }}>Unknown</td>
              <td style={{ padding: '10px' }}>1</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h4 style={{ color: '#ff9800' }}>Base MP (Fallback by Collection)</h4>
      <div style={{ overflowX: 'auto', marginBottom: '20px', border: '1px solid #444' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '14px' }}>
          <thead>
            <tr style={{ borderBottom: '2px solid #555', color: '#ff9800', backgroundColor: 'rgba(255,255,255,0.05)' }}>
              <th style={{ padding: '10px' }}>Collection Name</th>
              <th style={{ padding: '10px' }}>Criteria</th>
              <th style={{ padding: '10px' }}>Base MP</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/collection/syndicates21" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  syndicates21
                </a>
              </td>
              <td style={{ padding: '10px' }}>Any NFT from collection (excluding mobsters &amp; turf schemas, listed above)</td>
              <td style={{ padding: '10px' }}>400</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/collection/waxstation21" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  waxstation21
                </a>
              </td>
              <td style={{ padding: '10px' }}>Any NFT from collection</td>
              <td style={{ padding: '10px' }}>350</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/collection/pantheon" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  pantheon
                </a>
              </td>
              <td style={{ padding: '10px' }}>Any NFT from collection</td>
              <td style={{ padding: '10px' }}>300</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/collection/planetdefnft" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  planetdefnft
                </a>
              </td>
              <td style={{ padding: '10px' }}>Any NFT from collection</td>
              <td style={{ padding: '10px' }}>300</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/collection/facings" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  facings
                </a>
              </td>
              <td style={{ padding: '10px' }}>Any NFT from collection</td>
              <td style={{ padding: '10px' }}>250</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/collection/taco" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  taco
                </a>
              </td>
              <td style={{ padding: '10px' }}>Any NFT from collection</td>
              <td style={{ padding: '10px' }}>100</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/collection/mlb.topps" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  mlb.topps
                </a>
              </td>
              <td style={{ padding: '10px' }}>Any NFT from collection</td>
              <td style={{ padding: '10px' }}>50</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/collection/futuresrelic" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  futuresrelic
                </a>
              </td>
              <td style={{ padding: '10px' }}>Any NFT from collection</td>
              <td style={{ padding: '10px' }}>15</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/collection/alien.worlds" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  alien.worlds
                </a>
              </td>
              <td style={{ padding: '10px' }}>Any NFT from collection</td>
              <td style={{ padding: '10px' }}>10</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/collection/pigmentiawax" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  pigmentiawax
                </a>
              </td>
              <td style={{ padding: '10px' }}>Any NFT from collection</td>
              <td style={{ padding: '10px' }}>300</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/collection/wedare2dream" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  wedare2dream
                </a>
              </td>
              <td style={{ padding: '10px' }}>Per-template (same as idaretodream)</td>
              <td style={{ padding: '10px' }}>1 - 2,109,600</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h4 style={{ color: '#ff9800' }}>MP Boost (Gear & Emblems)</h4>
      <div style={{ overflowX: 'auto', marginBottom: '20px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '14px' }}>
          <thead>
            <tr style={{ borderBottom: '2px solid #555', color: '#ff9800', backgroundColor: 'rgba(255,255,255,0.05)' }}>
              <th style={{ padding: '10px' }}>Name</th>
              <th style={{ padding: '10px' }}>Rarity</th>
              <th style={{ padding: '10px' }}>Slot</th>
              <th style={{ padding: '10px' }}>MP Boost (%)</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889047" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Heartblade Of The Fire King
                </a>
              </td>
              <td style={{ padding: '10px' }}>Mystic</td>
              <td style={{ padding: '10px' }}>Sword</td>
              <td style={{ padding: '10px' }}>+200%</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889046" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Sword Of Raging Fire
                </a>
              </td>
              <td style={{ padding: '10px' }}>Legendary</td>
              <td style={{ padding: '10px' }}>Sword</td>
              <td style={{ padding: '10px' }}>+100%</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889043" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Embersteel Flamefang
                </a>
              </td>
              <td style={{ padding: '10px' }}>Epic</td>
              <td style={{ padding: '10px' }}>Sword</td>
              <td style={{ padding: '10px' }}>+50%</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/873626" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Phoenix Emblem
                </a>
              </td>
              <td style={{ padding: '10px' }}>Special</td>
              <td style={{ padding: '10px' }}>Emblem</td>
              <td style={{ padding: '10px' }}>+50%</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889017" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Inferno Edge
                </a>
              </td>
              <td style={{ padding: '10px' }}>Rare</td>
              <td style={{ padding: '10px' }}>Sword</td>
              <td style={{ padding: '10px' }}>+25%</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/886849" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Silver Emblem
                </a>
              </td>
              <td style={{ padding: '10px' }}>Special</td>
              <td style={{ padding: '10px' }}>Emblem</td>
              <td style={{ padding: '10px' }}>+25%</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889016" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Blade Of The Molten Path
                </a>
              </td>
              <td style={{ padding: '10px' }}>Uncommon</td>
              <td style={{ padding: '10px' }}>Sword</td>
              <td style={{ padding: '10px' }}>+12%</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/886848" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Bronze Emblem
                </a>
              </td>
              <td style={{ padding: '10px' }}>Special</td>
              <td style={{ padding: '10px' }}>Emblem</td>
              <td style={{ padding: '10px' }}>+10%</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #333' }}>
              <td style={{ padding: '10px', fontWeight: 'bold' }}>
                <a href="https://wax.atomichub.io/explorer/template/whatifreward/889015" target="_blank" rel="noopener noreferrer" style={{ color: '#00e5ff', textDecoration: 'none' }}>
                  Emberkind Training Sword
                </a>
              </td>
              <td style={{ padding: '10px' }}>Common</td>
              <td style={{ padding: '10px' }}>Sword</td>
              <td style={{ padding: '10px' }}>+5%</td>
            </tr>
          </tbody>
        </table>
      </div>

      <hr style={{ borderColor: '#444', margin: '40px 0 20px 0' }} />
      {!isNative && (
        <>
        <h3 style={{ color: '#00e5ff', marginTop: '30px', borderBottom: '1px solid #333', paddingBottom: '5px' }}>8. WHATIFXCHANGE & CONVERGENCE INDEX POWER</h3>
              <p>Dungeon For Riches is a core pillar of the <strong>WhatIf Hub Convergence</strong>, and the only game that feeds your <strong>Index Power</strong> on the Hub from <strong>two</strong> separate sources: your <strong>Mining Power</strong> from staked NFTs (boosts included), plus your <strong>Vault Score</strong> from tokens staked in the vault — FIREMAN, WHATIF, WTFBILL, WHATIFX, WTFWUF, PUZZL, TESTERU and XMASZS each carry their own weight. Playing multiple games (like Syndicate 21, Wax Station 21, and Puzzl Quest) multiplies your base Index Power: 2 games 1.10x, 3 games 1.25x, all 4 games 1.50x!</p>
              <p>Every time you swap tokens using the embedded <strong>WhatifXchange widget</strong>, <strong>50% of the swap fee</strong> is routed directly to the Convergence Daily Dividend Pool. You can claim a share of this pool every day on the WhatIf Hub, proportional to your Index Power. If you swap on the main WhatifXchange site without a widget, 100% of the fee stays with the DEX, so always use the in-game widgets to fund your own dividend pool!</p>

              </>
      )}

      <hr style={{ borderColor: '#444', margin: '40px 0 20px 0' }} />
      <h3 style={{ textAlign: 'center', fontSize: '1.5em' }}>Community & Socials</h3>
      <p style={{ textAlign: 'center', marginBottom: '25px', color: '#ccc' }}>Join the community and stay updated with live announcements:</p>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', flexWrap: 'wrap' }}>
        <a href="https://discord.gg/R9CPWqnnp2" target="_blank" rel="noopener noreferrer" className="modern-button" style={{ textDecoration: 'none' }}>Join our Discord</a>
        <a href="https://x.com/WHATIF_Rewards" target="_blank" rel="noopener noreferrer" className="modern-button" style={{ textDecoration: 'none' }}>Follow us on X</a>
        <a href="https://www.facebook.com/profile.php?id=61558433263890" target="_blank" rel="noopener noreferrer" className="modern-button" style={{ textDecoration: 'none' }}>Find us on Facebook</a>
      </div>
    </div>
  );
}

export default AboutUs;